import styled, { keyframes } from 'styled-components'

export const fadeSlideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const scaleIn = keyframes`
  0% {
    transform: scale(0);
    opacity: 0;
  }
  60% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`

export const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`

export const fadeOut = keyframes`
  from { opacity: 1; }
  to   { opacity: 0; }
`

export const FadeSlideUp = styled.div<{ $delay?: number }>`
  opacity: 0;
  animation: ${fadeSlideUp} 0.4s ease-out forwards;
  animation-delay: ${({ $delay = 0 }) => $delay}s;
`
